import { DateRanges } from '../DateRanges';
import { PHODPageData } from '../general';
import { getPHFilterFromSession } from './order-filter-utils';
import { IPHRequest, ISessionPHFilter } from '../../models/purchase-history';
import { IOPExpSessionData, TDateSelectValues } from '../../models/common';
import { dateTileOptions } from '../../constants/order-filter';

interface initPHRequestBuilderProps {
  customerType: string;
  customerRole: string;
  searchParams: URLSearchParams;
  dateSelectorValue: TDateSelectValues;
  svocID: string;
  initResultsFilter: 'allOrders' | 'myOrders';
}

export const initPHRequestBuilder = ({
  customerType,
  customerRole,
  searchParams,
  dateSelectorValue,
  svocID,
  initResultsFilter,
}: initPHRequestBuilderProps): IPHRequest => {
  const OPExpSessionData = PHODPageData();

  const createInitSearchBy = () => {
    if (
      searchParams.get('requestSearchSelectorValue') &&
      searchParams.get('requestSearchCriteria')
    ) {
      const criteria = searchParams.get('requestSearchSelectorValue') || '';
      const value = searchParams.get('requestSearchCriteria') || '';
      const initSearchBy = { [criteria]: value };
      return [initSearchBy];
    }
    return undefined;
  };
  if (customerType === 'b2b' || customerRole !== '') {
    return {
      pageSize: 20,
      pageNumber: (OPExpSessionData as IOPExpSessionData)?.lastPage ?? 1,
      startDate:
        searchParams.get('startDate') ||
        DateRanges[dateSelectorValue].startDate,
      endDate:
        searchParams.get('endDate') || DateRanges[dateSelectorValue].endDate,
      customerAccountId: svocID || '',
      sortBy: 'salesDate',
      sortOrder: 'desc',
      searchType: 'ORDERS',
      resultsFilter: initResultsFilter,
      searchBy: createInitSearchBy(),
    };
  }
  return {
    pageSize: 20,
    pageNumber: (OPExpSessionData as IOPExpSessionData)?.lastPage ?? 1,
    startDate: DateRanges[dateSelectorValue].startDate,
    endDate: DateRanges[dateSelectorValue].endDate,
  };
};

export const formatDate = (dateStr: string) => {
  if (!dateStr) return dateStr;
  const [part1, part2, part3] = dateStr.split('/');

  if (dateStr.includes('-')) return dateStr;

  if (part1 && part2 && part3) {
    return `${part3}-${part1.padStart(2, '0')}-${part2.padStart(2, '0')}`;
  }
  return dateStr;
};

export const getFilterDetailsFromSession = () => {
  const sanitized = getPHFilterFromSession();
  return Object.keys(sanitized).length ? sanitized : undefined;
};

export const getEffectiveFilterDateRange = (
  pHRequest: IPHRequest,
  sessionPHFilter: ISessionPHFilter | undefined,
) => {
  const startDate = pHRequest?.startDate?.split('-');
  const endDate = pHRequest?.endDate?.split('-');
  if (sessionPHFilter?.startDate && sessionPHFilter?.endDate) {
    return {
      startDate: sessionPHFilter.startDate,
      endDate: sessionPHFilter.endDate,
    };
  }
  if (startDate?.length === 3 && endDate?.length === 3) {
    return {
      startDate: `${startDate[1]}/${startDate[2]}/${startDate[0]}`,
      endDate: `${endDate[1]}/${endDate[2]}/${endDate[0]}`,
    };
  }
  return {
    startDate: '',
    endDate: '',
  };
};

export const getDateRangeFilterText = (
  dateSelectorValue: TDateSelectValues,
  pHRequest: IPHRequest,
) => {
  const sessionPHFilter = getFilterDetailsFromSession();
  const selectedDate = sessionPHFilter?.selectedDate || dateSelectorValue;
  if (selectedDate === 'custom') {
    const { startDate, endDate } = getEffectiveFilterDateRange(
      pHRequest,
      sessionPHFilter,
    );
    return startDate && endDate ? `${startDate} - ${endDate}` : '';
  }

  const selectedDateOption = dateTileOptions?.find(
    (option) => option?.value === selectedDate,
  );

  if (selectedDateOption?.label) return selectedDateOption.label;

  return '';
};
